<template>
  <!-- 货品添加弹窗-->
  <div >
    <div class="flexGrow1 flex marginBottom10">
      <div class="hHP w200 flex directionColumn">
        <el-tabs v-model="tabs">
          <el-tab-pane label="货品分类" name="1" />
          <el-tab-pane label="货品标签" name="2" />
        </el-tabs>
        <el-input v-model="filterText" class="wHP" placeholder="输入关键字" />
        <div class="marginTop10 h450 scrollbar">
          <el-tree v-show="tabs === '1'" ref="tree" show-checkbox class="filter-tree" node-key="id" :data="sortsData" :props="defaultProps" default-expand-all :filter-node-method="filterNode" @check-change="handleCheckChange" />
        </div>
      </div>
      <div class="marginLeft20 w800 paddingTop10 flexGrow1 flex">
        <div class="wFP flex directionColumn">
          <el-input v-model="search" placeholder="请输入内容" clearable class="w300" @change="queryPageStoreGoods">
            <el-button slot="append" icon="el-icon-search" @click="queryPageStoreGoods"></el-button>
          </el-input>
          <div class="marginTop10 bcGrey padding5 borderRadius5 paddingLeft20">当前选中 {{ tableData.length }} 项 <span class="pointer blue" @click="handleCancelChoose">取消选择</span></div>
          <div v-infinite-scroll="concatGoodsData" class="marginTop10 flexGrow1 scrollbar scrollAuto h400">
            <el-row>
              <el-checkbox-group v-model="checks" @change="handleChange">
                <el-col v-for="goods in goodsData" :key="goods.cremark" :span="6">
                  <div class="margin5 flex directionColumn" :style="{height: '115px', border: (goods.labels && goods.labels.indexOf('停采品') !== -1)  ? '1px solid red' : '1px solid #dedede'}">
                    <el-popover placement="bottom" trigger="hover">
                      <div class="w250 flex">
                        <div class="w60 paddingRight10 textCenter">
                          <el-image slot="reference" :src="goods.cmasterUrl" class="w50 h50" fit="fit" />
                          <div class="grey fs11">零售价</div>
                          <div class="fs11">{{ goods.nprice }}</div>
                        </div>
                        <div>
                          <a class="fs11 blue"> {{ goods.cname }}</a>
                          <div class="fs11">{{ goods.cremark }}</div>
                          <div class="marginTop10 grey fs11">
                            货品库存 <span class="fs11 black">{{ goods.nall }}</span>
                          </div>
                          <div class="grey fs11">
                            可用库存 <span class="fs11 black">{{ goods.navailable }}</span>
                          </div>
                          <div class="grey fs11">
                            货品库位 <span class="fs11 black">{{ goods.cwarehouse }}</span>
                          </div>
                          <div class="grey fs11">
                            货品规格 <span class="fs11 black">{{ goods.cspecification }}</span>
                          </div>
                        </div>
                      </div>
                      <el-checkbox :disabled="maxNum && goods.navailable === 0" slot="reference" class="marginLeft5" :label="goods.cremark">{{ goods.cremark }}</el-checkbox>
                    </el-popover>
                    <div class="flexGrow1">
                      <el-image :preview-src-list="[goods.cmasterUrl]" :src="goods.cmasterUrl" class="hHP wHP" fit="fit" />
                    </div>
                  </div>
                </el-col>
              </el-checkbox-group>
            </el-row>
          </div>
        </div>
        <div class="wFP paddingLeft20">
          <el-table ref="multipleTable" :data="tableData" class="popper-40 wHP" tooltip-effect="dark" @selection-change="handleSelectionChange" style="height: 555px;overflow: auto;">
            <el-table-column type="selection" width="40" />
            <el-table-column align="center" label="SKU1" width="50">
              <template slot-scope="scope">
                {{ scope.row.cremark }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="零售价" width="50">
              <template slot-scope="scope">{{ scope.row.nprice }}</template>
            </el-table-column>
            <el-table-column align="center" label="库位号" width="60">
              <template slot-scope="scope">{{ scope.row.cwarehouse }}</template>
            </el-table-column>
            <el-table-column align="center" label="数量">
              <template slot-scope="scope">
                <el-input-number style="width: 150px" v-if="maxNum" v-model="scope.row.num" :max="scope.row.navailable" :min="1" controls-position="right" />
                <el-input-number style="width: 150px" v-else v-model="scope.row.num" :min="1" controls-position="right" />
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="60">
              <template #default="scope">
                <i class="el-icon-delete pointer" @click="onDelete(scope.$index)"></i>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-row type="flex" justify="end">
      <el-button type="primary" plain @click="onCancel(true)">取 消</el-button>
      <el-button type="primary" @click="onSubmit">确 认</el-button>
    </el-row>
  </div>
</template>

<script>
import { topsUtils } from "@/utils/topsUtils";
import { goodsSortList, handleTree, materialCategoryTree } from "@/api/goods/goods";

export default {
  name: "OrderGoodsAdd",
  components: {
    // NoData,
  },
  props: {
    selectStore: {
      type: Object,
      default: () => {},
    },
    goods: {
      type: [String, Object, Array], // 根据需要指定数据类型
      default: "", // 设置一个默认值，如空字符串
    },
    maxNum: {
      type: Boolean,
      default: true, // 设置一个默认值，如空字符串
    },
  },
  data() {
    return {
      tabs: "1",
      activeName: "1",
      //树形图
      filterText: "",
      sortsData: [],
      sortsList: [],
      defaultProps: {
        children: "children",
        // label: "ssort",
        label: "categoryName",
      },
      selectIds: [],
      // 商品列表
      goodsData: [],
      // 搜索条件
      search: "",
      queryParams: {
        currentPage: 1,
        pageSize: 20,
        sortIds: "",
      },
      //选中列表
      tableData: [],
      //近似品
      similarList: [],
      //关联品
      relevanceList: [],
      checks: [],
      checkList: [],
      dialogVisible: false,
    };
  },
  computed: {
    topsUtils() {
      return topsUtils;
    },
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  mounted() {
    this.fetchGoodSorts();
    this.queryPageStoreGoods();
  },
  methods: {
    handleCancelChoose() {
      this.checks = [];
      this.tableData = [];
    },
    setTableData(tableData) {
      this.search = '';
      this.queryParams = {
        currentPage: 1,
        pageSize: 20,
        sortIds: "",
      }
      this.selectIds = [];
      this.tableData = tableData;
      this.checks = [];
      for (let i = 0; i < this.tableData.length;i++) {
        this.tableData[i].n_surplus = this.tableData[i].n_surplus < 0 ? 0 : this.tableData[i].n_surplus;
        this.checks.push(this.tableData[i].cremark);
      }
      this.checkList = [ ...this.tableData ];
      this.fetchGoodSorts();
      this.queryPageStoreGoods();
      this.dialogVisible = true;
    },
    handleChange() {
      let arr = []
      for (let i = 0; i < this.checks.length; i++) {
        for (let j = 0; j < this.checkList.length; j++) {
          if (this.checkList[j].cremark === this.checks[i]) {
            arr.push(this.checkList[j]);
          }
        }
      }
      this.tableData = arr;
    },
    /**
     * 获取库存信息
     */
    queryPageStoreGoods() {
      this.queryParams.currentPage = 1;
      let params = this.queryParams;
      params.storeId = this.selectStore.rstore;
      params.search = this.search;
      this.topsAjax.get(`${this.baseUrls.ordPicking}/queryGoods`, params).then((res) => {
        this.goodsData = res.list;
        for (let i = 0; i < this.goodsData.length;i++) {
          let isMatch = false;
          for (let j = 0; j < this.checkList.length; j++) {
            if (this.checkList[j].cremark === this.goodsData[i].cremark) {
              isMatch = true;
              break;
            }
          }
          if (!isMatch) {
            this.checkList.push(this.goodsData[i]);
          }
        }
      });
    },
    /**
     * 下拉刷新库存信息
     */
    concatGoodsData() {
      let url = `${this.baseUrls.ordPicking}/queryGoods`;
      this.queryParams.currentPage += 1;
      let params = this.queryParams;
      params.storeId = this.selectStore.rstore;
      params.search = this.search;
      this.topsAjax.get(url, params).then((res) => {
        
        let newList = res.list;
        for (let i = 0; i < newList.length; i++) {
          let isMatch = false;
          for (let j = 0; j < this.checkList.length; j++) {
            if (this.checkList[j].cremark === newList[i].cremark) {
              isMatch = true;
              break;
            }
          }
          if (!isMatch) {
            this.checkList.push(newList[i]);
          }
        }
        this.goodsData = this.goodsData.concat(newList);
      });
    },
    /**
     * 获取分类树
     */
    fetchGoodSorts() {
      // goodsSortList().then((response) => {
      //   this.sortsList = response.data;
      //   this.sortsData = handleTree(response.data, "sid", "rsort");
      // });
      // materialCategoryTree().then((response) => {
      //   for (let i = 0; i < response.data.length; i++) {
      //     response.data[i].label = response.data[i].ssort
      //     response.data[i].categoryName = response.data[i].ssort
      //   }
      //   console.log(response.data)
      //   this.sortsData = handleTree(response.data, "sid", "rsort");
      // });
      materialCategoryTree().then((response) => {
        this.sortsData = handleTree(response.data, "id", "parent");
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      // return data.ssort.indexOf(value) !== -1;
      return data.categoryName.indexOf(value) !== -1;
    },
    handleCheckChange(data, checked) {
      if (checked) {
        this.selectIds.push(data.id);
      } else {
        const index = this.selectIds.indexOf(data.id);
        if (index > -1) {
          this.selectIds.splice(index, 1);
        }
      }
      let ids = this.selectIds.join(",")
      if (this.queryParams.sortIds !== ids) {
        this.queryParams.sortIds = ids;
        this.queryPageStoreGoods();
      }
      
    },
    /**
     * 打开近似商品
     */
    openSimilar() {
      if (!this.checkGoods.sid) {
        this.$message.error("请选择一种商品");
        return;
      } else {
        this.similarData = this.goodsList.filter((item) => item.r_sort === this.checkGoods.r_sort && item.r_goods !== this.checkGoods.r_goods);
        this.dialogVisible = true;
      }
    },
    /**
     * 选中近似商品
     * @param val
     */
    onChangeSimilarData(val) {
      if (val.length === 0) {
        this.replaceGoods = "";
      } else if (val.length === 1) {
        this.replaceGoods = val[0];
      } else {
        this.$refs.similarTable.clearSelection();
        this.$refs.similarTable.toggleRowSelection(val[val.length - 1]);
      }
    },
    /**
     * 选中要替换的商品
     * @param val
     */
    handleSelectionChange(val) {
      if (val.length === 0) {
        this.checkGoodsIndex = "";
        this.checkGoods = "";
      } else if (val.length === 1) {
        this.checkGoodsIndex = this.tableData.findIndex((data) => data === val[0]);
        this.checkGoods = val[0];
      } else {
        this.$refs.multipleTable.clearSelection();
        this.$refs.multipleTable.toggleRowSelection(val[val.length - 1]);
      }
    },
    /**
     * 输入后新增
     * @param row
     */
    handleBlur(row) {
      let item = this.tableData[this.tableData.length - 1];
      if (row.num) {
        if (item?.barcode && item?.num) {
          this.tableData.push({});
        }
      }
      // if (row.nSurplus) {
      //   if (item?.rGoods && item?.rWarehouse && item?.nSurplus) {
      //     this.tableData.push({});
      //   }
      // }
    },
    /**
     * 刪除
     * @param index
     */
    onDelete(index) {
      this.tableData.splice(index, 1);
    },
    onCancel(value) {
      this.dialogVisible = false;
      let arr = [];
      for (let i = 0; i < this.tableData.length; i++) {
        arr.push({ ...this.tableData[i] });
      }
      this.$emit("OrderGoodsAdd", value ? [] : arr);
    },
    onSubmit() {
      let newArray = this.tableData;
      let flag = false;
      let skuMap = {}; // 用来记录每个 SKU 的出现次数
      newArray.forEach((p) => {
        if (p.num === undefined || p.num === "" || p.num < 1) {
          flag = true;
          this.$message.error(`商品出库数至少要为1！`);
        }
        // 检查 SKU 是否重复
        if (skuMap[p.cremark]) {
          flag = true;
          this.$message.error(`商品 SKU ${p.cremark} 存在重复！`);
        } else {
          skuMap[p.cremark] = true;
        }
      });
      if (flag) return;
      this.$emit("handleChoose", newArray);
    },
  },
};
</script>

<style lang="scss">
.newOrderGoodsAdd {
  height: 600px;
  background-color: white;
  display: flex;
  flex-direction: column;

  .el-tabs__item {
    padding: 0 10px;
  }

  .el-tabs__item.is-active {
    text-decoration: underline;
  }

  .el-popper[x-placement^="bottom"] {
    margin-left: -40px;
  }
}
</style>
